export const blockIconsFileCloudDownload = (
	<span className='material-symbols-outlined'>cloud_download</span>
);
